import React from "react";
import { DataGrid } from "devextreme-react";
import uri from "../../utils/uri";
import { store } from "../../services/store";
import { Column, Editing, Form, Paging, Popup, RequiredRule, StringLengthRule } from "devextreme-react/data-grid";
import BlockHeader from '../../components/shared/BlockHeader';
import Title from "../../components/shared/Title";
import { formatPad } from "../../utils/common";

const ScleralsConfig = () => {
    const onCellPrepared = e => {

        if (e.rowType == 'data') {

            if (e.column.dataField == "negativo")
                e.cellElement.classList.add('negative');

        }

    }

    const title = "Tabla de Lentes Sclerales";

    return (
        <div className="container small">
            <Title title={title} />
            <BlockHeader title={title} />
            <DataGrid
                dataSource={store({ uri: uri.sclerals })}
                showBorders={true}
                showRowLines={true}
                onCellPrepared={onCellPrepared}
            >
                <Paging defaultPageSize={22} />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowDeleting={false}
                    allowAdding={false}
                    useIcons={true}

                >
                    <Popup width={600} height={200}>
                    </Popup>                    
                </Editing>
                <Column dataField="letter" caption="Letra" allowEditing={false} />
                <Column dataField="diameterUnit" caption="Diametro Unid" />
                <Column dataField="diameter" caption="Diametro" />
                <Column dataField="sagittal" caption="Sagittal Height" />
                <Column dataField="scleralZf" caption="Zone Flat" />
                <Column dataField="scleralZs" caption="Zone Steep" />
                <Column dataField="power" caption="Power" />
                <Column dataField="centerThickness" caption="Center Thickness" />
            </DataGrid>

        </div>
    );
}

export default ScleralsConfig;
